/**
 * Zeitraum der Analyse (Beta-Feedback 2026-10-07). Monatsgenau, damit das
 * Einkaufsvolumen ganze Monate vergleicht; der laufende Monat zählt bei den
 * Mehrkosten mit und wird beim Einkaufsvolumen als „läuft noch“ gezeigt.
 */
export const ANALYSIS_PERIODS = ["12m", "ytd", "last_year", "36m", "all", "custom"] as const;
export type AnalysisPeriod = (typeof ANALYSIS_PERIODS)[number];

export const ANALYSIS_PERIOD_LABELS: Record<AnalysisPeriod, string> = {
  "12m": "Letzte 12 Monate",
  ytd: "Dieses Jahr",
  last_year: "Letztes Jahr",
  "36m": "Letzte 3 Jahre",
  all: "Gesamter Zeitraum",
  custom: "Eigener Zeitraum",
};

function iso(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Von/Bis eines Zeitraums; „Gesamt“ und „Eigener“ geben keine Grenzen vor. */
export function analysisPeriodRange(period: AnalysisPeriod, today = new Date()): { from?: string; to?: string } {
  const year = today.getFullYear();
  const month = today.getMonth();
  switch (period) {
    case "12m":
      return { from: iso(new Date(year, month - 12, 1)), to: iso(today) };
    case "36m":
      return { from: iso(new Date(year, month - 36, 1)), to: iso(today) };
    case "ytd":
      return { from: `${year}-01-01`, to: iso(today) };
    case "last_year":
      return { from: `${year - 1}-01-01`, to: `${year - 1}-12-31` };
    case "all":
    case "custom":
      return {};
  }
}
